var _ = require("underscore");
var cio_datamodel = require("cio-datamodel");
var toSVGutil = require("./toSVGutil");

var drawLineDataTo2D = function (svg, group, data, attrs) {
    console.assert(data instanceof cio_datamodel.LineData);
    var attrs_total = {
    	'stroke-linecap': "round"
    };
    _.extend(attrs_total, toSVGutil.styleToAttributes(data));
    if(attrs) _.extend(attrs_total, attrs);

    return svg.line(group,
        data.x1(),
        data.y1(),
        data.x2(),
        data.y2(),
        attrs_total);
};

module.exports = drawLineDataTo2D;
